export default "__VITE_ASSET__CNiOD2a6__"